import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { ServicePathsSettings } from '../../../../core/configuration/service-paths-settings';
import { RicercaAnagraficheFormComponent } from '../../../form/ricerca-anagrafiche-form.component';
import { Legale } from '../../../models/legale';
import { SezioneLegali } from '../../../models/sezioni/sezione-legali';
import { LegaleAnagraficaAddComponent } from './legale-anagrafica-add.component';
import { LegaliAssociativaAddComponent } from './legali-associativa-add.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';

declare var closeModal: any;
declare var openModal: any;
declare var $: any;

@Component({
    selector: 'div [legali-mod-add]',
  templateUrl: 'legali-mod-aggiungi.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class LegaliModAggiungi {
  haveNewAnagrafica: boolean = false;
  viewSearchMask: boolean = true;
  addLegaleUrl: string;
  idSezione: string;
  sezioneLegali:SezioneLegali;
  idFascicolo: string;
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Output() onReturn: EventEmitter<SezioneLegali> = new EventEmitter<SezioneLegali>();
  @Output() modificaTariffa: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('formAddAnagrafica') modaleAnagrafica: LegaleAnagraficaAddComponent;
  @ViewChild('formAddAssociativaAnagrafica') modaleAssociativaAnagrafica: LegaliAssociativaAddComponent;
  @ViewChild('formRicercaLegale') modaleRicerca: RicercaAnagraficheFormComponent<Legale>;
  @ViewChild('formAddAssociativaRicerca') modaleAssociativaRicerca: LegaliAssociativaAddComponent;

  constructor(private modal : DialogService){}

  inizializza(urlAggiungiInAnagrafica: string, addLegaleUrl, idSezione, idFascicolo,sezione: SezioneLegali) {
    this.addLegaleUrl = addLegaleUrl;
    this.sezioneLegali = sezione;
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.modaleAnagrafica.inizializza(urlAggiungiInAnagrafica);
    this.modaleRicerca.inizializza(ServicePathsSettings.URL_SEARCH_LEGALE, false);
    $('a[href="#tabcontent7"]').tab('show');
    openModal('modalmodaggiungi');
  }

  createForm() {
    this.haveNewAnagrafica = false;
    this.viewSearchMask = true;
    $('a[href="#tabcontent7"]').tab('show');
    if (this.modaleRicerca) {
      this.modaleRicerca.setTextEmpty();
      this.modaleRicerca.resetResults();
    }
    this.modaleAnagrafica.createForm();
  }

  newAnagrafica(legale: Legale) {
    this.haveNewAnagrafica = true;
    this.modaleAssociativaAnagrafica.inizializza(legale, this.addLegaleUrl, this.idSezione, this.idFascicolo);
  }

  // onEditTariffa(event){
  //   this.modificaTariffa.emit(event);
  // }

  // tariffaEdited(event){
  //   this.modaleAssociativaAnagrafica.tariffaModificata(event);
  // }

  manageModal(sezione: SezioneLegali) {
      this.createForm();
      closeModal('modalmodaggiungi');
      this.onReturn.emit(sezione);
  }

  foundedAnagrafica(legale: Legale) {
    if(this.sezioneLegali && this.sezioneLegali.legaliIncaricati.length > 0 && !!this.sezioneLegali.legaliIncaricati.find((value =>  value.legale.id === legale.id))){
      closeModal('modalmodaggiungi');
      this.modal.open(ConfirmModalComponent,{
        data : {
          title: 'Conferma',
          modalConfirm:{
            hideButtons: true,
            confirmButton: true,
            text:"Il Legale è già associato al Fascicolo"
          },
          style: {width: "50%"},
          formSettings : {
            formEdit : true,
            formData : ""
          }
        }
      })
    } else {
      this.viewSearchMask = false;
      this.modaleAssociativaRicerca.inizializza(legale, this.addLegaleUrl, this.idSezione, this.idFascicolo);
    }
  }
}
